import React from 'react';

const DesignEditInput = ({ inputClassName = '', label, value, onChangeHandler, type, name, ...props }) => {
	return (
		<div className="style-single mb-2">
			<div className="label-and-info d-flex align-items-center ">
				<div className="label mr-2">
					<p className="regular-12 weight-500 gray_dark_02">{label}</p>
				</div>

				<div className="form-group mb-0">
					<input
						className={inputClassName}
						type={type}
						autoComplete="off"
						name={name}
						id={name}
						value={value}
						onChange={onChangeHandler}
						{...props}
						autoFocus
					/>
				</div>
			</div>
		</div>
	);
};

export default DesignEditInput;
